import { useEffect } from 'react';

/**
 * A hook that automatically adjusts the height of a textarea based on its content
 * @param textAreaRef - Reference to the textarea element
 * @param value - The current value of the textarea
 */
export const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | null,
  value: string
) => {
  useEffect(() => {
    if (textAreaRef) {
      // Reset the height to ensure proper calculation
      textAreaRef.style.height = '0px';
      
      // Set the new height based on scrollHeight
      const scrollHeight = textAreaRef.scrollHeight;
      textAreaRef.style.height = `${scrollHeight}px`;
    }
  }, [textAreaRef, value]);
}; 